package ir.hosen.resume.util

enum class ScreenItem(val id: String, val title: String) {
    Home(id = "home", title = "Home"),
    ABOUT(id = "about", title = "About"),
    EXPERIENCE(id = "experience", title = "Experience"),
    Projects(id = "projects", title = "Projects"),
}